export function createOnlineQueueStore() {
    return {
        namespaced: true,

        state: {
            /**
             * Returns the total number of tasks that are not resolved.
             * This means those that are pending, currently running, or finished.
             * Note that finished tasks are deleted upon completion, so those won't stick around long.
             *
             * This may be null if the count is not loaded yet, which will be the case when the app starts up.
             *
             * @type {number|null}
             */
            queuedTaskCount: null,
        },

        mutations: {
            setQueuedTaskCount(state, count) {
                state.queuedTaskCount = count;
            },
        },
    };
}
